import { z } from "zod";

export const submitPhotoRouletteAnswerSchema = z.object({
	round: z.number().int().nonnegative(),
	guessed_user_id: z.string().min(1),
	answered_at: z.number().int().positive(),
});

export type SubmitPhotoRouletteAnswerPayload = z.infer<typeof submitPhotoRouletteAnswerSchema>;
